import { render, staticRenderFns } from "./169.vue?vue&type=template&id=2b5a507a&scoped=true&"
var script = {}
import style0 from "./169.vue?vue&type=style&index=0&id=2b5a507a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5a507a",
  null
  
)

export default component.exports